(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    const applyReturnPrimeTheme = () => {
    const setStyle = (element, property, value, expectedValue) => {
      if (element && getComputedStyle(element).getPropertyValue(property).trim() !== expectedValue) {
        element.style.setProperty(property, value, 'important');
      }
    };

    const frame = document.querySelector('#returnprime-root .Polaris-Frame');
    setStyle(frame, 'background-color', '#fff', 'rgb(255, 255, 255)');

    const searchCard = document.querySelector('#returnprime-root .customer__search');
    if (searchCard) {
      setStyle(searchCard, 'background-color', '#fff', 'rgb(255, 255, 255)');
      setStyle(searchCard, 'border-radius', '0', '0px');
      setStyle(searchCard, 'border-color', 'rgba(36, 35, 31, .45)', 'rgba(36, 35, 31, 0.45)');
      setStyle(searchCard, 'box-shadow', 'none', 'none');
    }

    const submitButton = document.querySelector('#returnprime-root .btn-primary');
    if (submitButton) {
      setStyle(submitButton, 'background-color', '#24231f', 'rgb(36, 35, 31)');
      setStyle(submitButton, 'border-color', '#24231f', 'rgb(36, 35, 31)');
      setStyle(submitButton, 'border-radius', '0', '0px');
      setStyle(submitButton, 'box-shadow', 'none', 'none');
      setStyle(submitButton, 'color', '#fff', 'rgb(255, 255, 255)');
    }
  };

  applyReturnPrimeTheme();
  document.addEventListener('DOMContentLoaded', applyReturnPrimeTheme);
  window.addEventListener('load', applyReturnPrimeTheme);
  const returnPrimeObserver = new MutationObserver(applyReturnPrimeTheme);
  returnPrimeObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style'],
  });

  [100, 300, 750, 1500, 3000].forEach((delay) => {
    window.setTimeout(applyReturnPrimeTheme, delay);
  });
  } catch(e) { console.error(e); }
})();

})();
